import { selectAnatomy } from "@ark-ui/react/select";
import { defineSlotRecipe } from "@chakra-ui/react";

export default defineSlotRecipe({
  className: "chakra-select",
  slots: selectAnatomy.extendWith("indicatorGroup").keys(),
  variants: {
    variant: {
      workspace: {
        trigger: {
          background: "colorPalette.contrast/5",
          borderColor: "transparent",
          borderWidth: "1",
          color: "colorPalette.contrast",
          _hover: {
            background: "colorPalette.contrast/10",
            borderColor: "colorPalette.contrast/15",
          },
          _focus: {
            borderColor: "colorPalette.contrast/15",
          },
        },
      },
    },
  },
});
